/**
 * Client-side cookie utilities
 * These are minimal client-side wrappers to set cookies from the browser
 * IMPORTANT: Cookie names must match cookieOptions.ts definitions:
 * - "mlbauthToken" for auth token
 * - "mlbSessionKey" for session key
 */

export function setClientCookie(name: string, value: string, days: number = 7) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
}

export function getClientCookie(name: string): string | null {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  } 
  return null;
}

export function deleteClientCookie(name: string) {
  setClientCookie(name, "", -1);
}

// Auth-specific helpers - Use correct cookie names from cookieOptions.ts
export function setAuthTokenCookie(token: string) {
  setClientCookie("mlbauthToken", token, 7);
}

export function getAuthTokenCookie(): string | null {
  return getClientCookie("mlbauthToken");
}

export function deleteAuthTokenCookie() {
  deleteClientCookie("mlbauthToken");
}

export function setSessionKeyCookie(sessionKey: string) {
  setClientCookie("mlbSessionKey", sessionKey, 7);
}

export function getSessionKeyCookie(): string | null {
  return getClientCookie("mlbSessionKey");
}

export function deleteSessionKeyCookie() {
  deleteClientCookie("mlbSessionKey");
}

export function setRefreshTokenCookie(refreshToken: string) {
  setClientCookie("mlbRefreshToken", refreshToken, 7);
}

export function getRefreshTokenCookie(): string | null {
  return getClientCookie("mlbRefreshToken");
}

export function deleteRefreshTokenCookie() {
  deleteClientCookie("mlbRefreshToken");
}
